"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const jsx_runtime_1 = require("react/jsx-runtime");
const SvgDropdown = props => (0, jsx_runtime_1.jsx)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  ...props,
  children: (0, jsx_runtime_1.jsxs)("g", {
    opacity: 0.6,
    children: [(0, jsx_runtime_1.jsx)("path", {
      "data-name": "Path 13",
      d: "M0 16V0h16v16z",
      fill: "none"
    }), (0, jsx_runtime_1.jsx)("path", {
      "data-name": "Path 14",
      d: "M4.933 5.721l-.942.942L8 10.672l4.009-4.009-.942-.942L8 8.781z"
    })]
  })
});
exports.default = SvgDropdown;